import {useLazyQuery} from '@apollo/client';
import {useMemo} from 'react';
import {GENERIC_SOFT_DELETE} from '../../components/AccountOverview/accountOverviewQueries';
import {
  GenericSoftDeleted,
  GenericSoftDeletedVariables,
} from '../../schema-types/GenericSoftDeleted';

export const useSoftDelete = () => {
  const [softDeletedEntities, {data, loading: softDeleteLoading}] = useLazyQuery<
    GenericSoftDeleted,
    GenericSoftDeletedVariables
  >(GENERIC_SOFT_DELETE);

  const softDeleteData = useMemo(() => {
    return data?.genericSoftDeleted ?? [];
  }, [data?.genericSoftDeleted]);

  return {
    softDeletedEntities,
    softDeleteData,
    softDeleteLoading,
  };
};
